import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_AUTH_API_URL,
  headers: {
    'Content-Type': 'application/json',
    APIKey: process.env.VUE_APP_AUTH_API_KEY,
    ENV: process.env.VUE_APP_ENV,
    Authorization: null
  }
});

export default {
  post (url, payload) {
   return apiClient.post(url, payload);
  },
  get (url, payload) {
    return apiClient.get(url, payload);
  },
  put (url, payload) {
    return apiClient.put(url, payload);
  }
};
